import gql from 'graphql-tag';

import { AvatarPhoto } from '../../../../graphql/fragments/account';
import { PhotoUrlTypeFields } from '../../graphql/fragments/global';
import { AlbumRootAlbumFolderBaseDetails } from '../../../../graphql/fragments/album';

export const joinCodeSearch = gql`
  query joinCodeByCode($code: String!) {
    joinCodeByCode(code: $code) {
      album {
        id
        name
        start_date
        album_type
        album_subtype
        join_code
        is_web_gallery
        all_photos_mode
        cover_photo {
          id
          thumbnail_urls {
            ...PhotoUrlTypeFields
          }
        }
        creator {
          id
          username
          name
          organization_name
          ...AvatarPhoto
        }
        has_password
        joins_enabled
        auto_contributor_settings {
          upload_access
        }
        ...AlbumRootAlbumFolderBaseDetails
      }
      album_folder {
        id
        name
        description
        join_code
        created_at
        start_date
        end_date
        album_type
        album_subtype
        event_venue
        all_photos_mode
        cover_photos(slice: { limit: 1 }) {
          count
          total
          records {
            id
            faces_box
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
          }
        }
        children {
          albums {
            total
            records {
              name
              cover_photo {
                id
                thumbnail_urls {
                  ...PhotoUrlTypeFields
                }
              }
            }
          }
        }
        start_date
        end_date
        account {
          id
          username
          name
          organization_name
          ...AvatarPhoto
        }
        has_password
        root {
          id
          all_photos_mode
        }
        is_web_gallery
        joins_enabled
        tags(slice: { limit: 5 }) {
          records {
            id
            ... on IAlbumFolderTag {
              name
              type
            }
          }
        }
        auto_contributor_settings {
          upload_access
        }
      }
    }
  }
  ${AvatarPhoto}
  ${PhotoUrlTypeFields}
  ${AlbumRootAlbumFolderBaseDetails}
`;

export const accountSearch = gql`
  query accountSearch($query: String!, $limit: Int = 30, $offset: Int = 0) {
    accountProfileSearch(
      account_search_query: $query
      slice: { limit: $limit, offset: $offset }
      include_pro_accounts: true
      pro_accounts_only: true
    ) {
      items {
        total
        records {
          id
          username
          name
          roles
          organization_name
          logo_image {
            id
            url
          }
          avatar_photo {
            id
            thumbnail_urls {
              size_code
              url
              width
              height
            }
          }
          hierarchy_items(web_galleries_only: true) {
            total
          }
          future_hierarchy_items: hierarchy_items(
            date_filters: [PRESENT, FUTURE]
            with_join_code_only: true
            web_galleries_only: false
          ) {
            total
          }
          past_hierarchy_items: hierarchy_items(
            date_filters: [PAST, UNSPECIFIED]
            with_join_code_only: true
            web_galleries_only: false
          ) {
            total
          }
        }
      }
    }
  }
`;

export const ProDirectorySearch = gql`
  query proDirectorySearch(
    $location_point: LocationPointInput!
    $limit: Int = 30
    $offset: Int = 0
  ) {
    proDirectorySearch(
      slice: { limit: $limit, offset: $offset }
      location_point: $location_point
    ) {
      items {
        total
        records {
          id
          organization_name
          site_url
          pro_directory_description
          logo_image {
            id
            url
          }
          hero_image {
            id
            url
          }
          pro_directory_asset_image {
            id
            url
          }
        }
      }
    }
  }
`;
